import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';

type Params = {
  useNumericKeys?: boolean;
};
export const useBooleanChoices = ({ useNumericKeys = false }: Params = {}) => {
  const translate = useTypedTranslate();

  if (useNumericKeys) {
    return [
      { id: '1', name: translate('app.common.yes') },
      { id: '0', name: translate('app.common.no') },
    ];
  }
  return [
    { id: true, name: translate('app.common.yes') },
    { id: false, name: translate('app.common.no') },
  ];
};
